import * as z from 'zod/mini';
/**
 * Ready message sent from server to client after WebSocket connection is established.
 * The client should wait for this message before considering the connection fully ready.
 */
export const ActorReady = z.object({
    /** Message type identifier */
    type: z.literal('RDY'),
    /** Server timestamp */
    ts: z.number(),
    /** ID of the host sending the ready message */
    hostId: z.string(),
});
//# sourceMappingURL=ActorReady.js.map